import Markdown from "react-markdown";

export default function ChatMessage({ children, isUser, variant }) {
	let className = "chatMessage";
	if (variant === "system") {
		className += " chatMessageSystem";
	} else if (isUser) {
		className += " chatMessageYours";
	} else {
		className += " chatMessageTheirs";
	}
	return (
		<div className={className}>
			<Markdown>{ children }</Markdown>
		</div>
	);
}
